import React from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import styled from 'styled-components';
var AgroTextButton = withCssProps(function (_ref) {
  var text = _ref.text,
    parentCallback = _ref.parentCallback,
    children = _ref.children,
    _ref$elementId = _ref.elementId,
    elementId = _ref$elementId === void 0 ? null : _ref$elementId;
  var clicked = function clicked(event) {
    if (parentCallback) {
      parentCallback();
    }
  };
  return /*#__PURE__*/React.createElement(TextBtn, {
    onClick: function onClick(event) {
      return clicked(event);
    },
    id: elementId ? elementId : null,
    "data-cy": "agro-text-button"
  }, text, children);
});
AgroTextButton.displayName = 'AgroTextButton';
export { AgroTextButton };
AgroTextButton.propTypes = {
  text: PropTypes.string,
  parentCallback: PropTypes.func,
  children: PropTypes.node,
  elementId: PropTypes.string
};
var TextBtn = styled.button.withConfig({
  displayName: "AgroTextButton__TextBtn",
  componentId: "sc-149gc6h-0"
})(["background-color:transparent;font-family:'Montserrat',sans-serif;font-size:14px;font-weight:500;line-height:20px;letter-spacing:-0.2px;text-transform:capitalize;margin-right:0;border:none;cursor:pointer;line-height:18px;color:", ";-webkit-text-decoration:none;text-decoration:none;vertical-align:middle;display:flex;align-items:center;&:focus{outline:none;}&:hover{color:", ";}&:active{color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray800;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray900;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
});